import React from 'react';
import clsx from 'clsx';
import { PfmeaItem } from '../../types';

interface ApprovalModalProps {
    isDark: boolean;
    item: PfmeaItem | null;
    action: 'approve' | 'reject' | null;
    comment: string;
    onCommentChange: (val: string) => void;
    onClose: () => void;
    onConfirm: () => void;
    processing: boolean;
    userEmail?: string;
}

const ApprovalModal: React.FC<ApprovalModalProps> = ({ isDark, item, action, comment, onCommentChange, onClose, onConfirm, processing, userEmail }) => {
    if (!item || !action) return null;
    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className={clsx('w-full max-w-md rounded-xl p-6', isDark ? 'bg-slate-800' : 'bg-white')}>
                <h2 className={clsx('text-xl font-bold mb-4', isDark ? 'text-white' : 'text-slate-800')}>{action === 'approve' ? 'Approve Item' : 'Reject Item'}</h2>
                <div className={clsx('p-3 rounded-lg mb-4', isDark ? 'bg-slate-700' : 'bg-slate-50')}>
                    <p className="text-sm text-slate-500">Process Step</p>
                    <p className={clsx('font-medium', isDark ? 'text-white' : 'text-slate-800')}>{item.processStepNumber} - {item.processStepName}</p>
                    <p className="text-sm text-slate-500 mt-1">Failure Mode: {item.failureMode}</p>
                </div>
                <div className="mb-4">
                    <label className={clsx('block text-sm font-medium mb-2', isDark ? 'text-white' : 'text-slate-700')}>{action === 'approve' ? 'Comment (optional)' : 'Reason for rejection *'}</label>
                    <textarea value={comment} onChange={(e) => onCommentChange(e.target.value)} rows={3} className={clsx('w-full px-3 py-2 rounded-lg border text-sm', isDark ? 'bg-slate-700 border-slate-600 text-white' : 'bg-white border-slate-200')} />
                </div>
                <div className="flex items-center justify-between text-sm text-slate-500 mb-4"><span>Signed as: {userEmail}</span><span>{new Date().toLocaleString()}</span></div>
                <div className="flex gap-3">
                    <button onClick={onClose} className="flex-1 px-4 py-2 text-sm border border-slate-200 dark:border-slate-600 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-700">Cancel</button>
                    <button onClick={onConfirm} disabled={processing || (action === 'reject' && !comment.trim())} className={clsx('flex-1 px-4 py-2 text-sm text-white rounded-lg disabled:opacity-50', action === 'approve' ? 'bg-green-500 hover:bg-green-600' : 'bg-red-500 hover:bg-red-600')}>
                        {processing ? 'Processing...' : action === 'approve' ? 'Confirm Approval' : 'Confirm Rejection'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ApprovalModal;
